export enum WidgetReservedParameters {
  storeId = 'storeId',
  sessionDate = 'SessionDate'
}
